import { BrowserStorageDataStore } from './browser-storage-data-store';

/**
 * Defines a single value data store using browser local storage as the underlying storage mechanism
 * This data store uses the provided storage key to get/set/clear a value from LocalStorage.
 */
export abstract class LocalDataStore<T> extends BrowserStorageDataStore<T> {
    constructor(storageKey: string) {
        super(storageKey, MsftSme.LocalStorageHandler.getLocalStorage());
    }
}
